export default __webpack_public_path__ + "static/media/certificate-header-ico.36f12eec.svg";